import { createSlice } from '@reduxjs/toolkit';
import { additionalDataType } from '@repo/onb-api';

const initialState: additionalDataType = {
  returnURLInitialize: '',
  returnURLError: '',
  returnURLSuccess: '',
  integrationTypeInitialize: '',
  orderIdInitialize: '',
  internal: false,
  orderId: '',
  integrationType: '',
  policyProduct: '',
  utmData: '',
  requestedAmount: '',
  documentNumber: '',
  merchantName: '',
  price: '',
  merchantOrderId: '',
};

export const additionalDataSlice = createSlice({
  name: 'additionalData',
  initialState,
  reducers: {
    setAdditionalData: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetAdditionalData: () => initialState,
  },
});

export const { setAdditionalData, resetAdditionalData } = additionalDataSlice.actions;

export default additionalDataSlice.reducer;
